import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

export const GET_SHOPPING_BUNDLE = gql`
  query GetShoppingBundle($request: ShoppingBundleRequest!) 
  @update_groups(groups: "${DEFAULT_GROUP},updateShoppingBasketProduct")
  {
    getShoppingBundle(request: $request) {
      membershipPerks {
        perks {
          discount {
            currency
            amount
          }
          isApplied
          perkType
        }
      }
      buyer {
        mail
        name
        lastNames
        userRegistered
      }
      travellers {
        numPassenger
        personalInfo {
          name
          firstLastName
          secondLastName
        }
      }
      products {
        id {
          type
        }
        price {
          amount
          currency
        }
      }
    }
  }
`;
